import axios from "axios";

import { INoContentResponse } from "@krea/shared/types/response";

export const selectCurrentLoanApplication = async (id: string) => {
  await axios.post<INoContentResponse>(
    "/api/v1/current-loan-application/select",
    {
      loan_application_id: id,
    },
  );
};

export const submitApplication = async () => {
  return axios.post<INoContentResponse>(
    "/api/v1/current-loan-application/submit",
  );
};

export const acceptAdvice = async () => {
  return axios.post<INoContentResponse>(
    "api/v1/current-loan-application/accept-advisory",
  );
};

export const withdrawAccept = async () => {
  return axios.delete<INoContentResponse>(
    "api/v1/current-loan-application/accept-advisory",
  );
};
